import { Button, MenuItem, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getOtGeneral } from "../../../../redux/slices/informes";
import { useEffect } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getAllClients } from "../../../../redux/slices/clients";

export default function FilterOtGeneral() {
  const { data: client } = useSelector((state) => state.clients);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  useEffect(() => {
    Promise.all([dispatch(getAllClients())]);
  }, []);

  const submitData = (values) => {
    dispatch(
      getOtGeneral({
        initial_date: values.initial_date,
        final_date: values.final_date,
        client: values.client,
        n_oc: values.n_oc,
      })
    );
  };

  return (
    <form onSubmit={handleSubmit(submitData)} className="flex gap-4">
      <div className="w-full flex">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            id={"initial_date"}
            control={control}
            // rules={{ required: true }}
            name={"initial_date"}
            // defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    sx: { mr: "20px" },
                    error: !!errors["initial_date"],
                    // helperText: errors['fecha_ingreso'] && ListOfErrors[errors['fecha_ingreso'].type],
                  },
                }}
                onChange={onChange}
                value={value || null}
              />
            )}
          />
        </LocalizationProvider>
      </div>
      <div className="w-full flex">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            id={"final_date"}
            control={control}
            // rules={{ required: true }}
            name={"final_date"}
            // defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    sx: { mr: "20px" },
                    error: !!errors["final_date"],
                    // helperText: errors['fecha_ingreso'] && ListOfErrors[errors['fecha_ingreso'].type],
                  },
                }}
                onChange={onChange}
                value={value || null}
              />
            )}
          />
        </LocalizationProvider>
      </div>
      <Controller
        id="client"
        name="client"
        control={control}
        // rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <TextField
            fullWidth
            select
            size="small"
            onChange={onChange}
            value={value || ""}
            label="Cliente"
            error={errors["client"]}
            placeholder=""
            sx={{
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
              },
            }}
          />
        )}
      />
      <Controller
        id="n_oc"
        name="n_oc"
        control={control}
        // rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <TextField
            fullWidth
            size="small"
            onChange={onChange}
            value={value || ""}
            label="Nro OC"
            error={errors["n_oc"]}
            placeholder=""
            sx={{
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
              },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              },
            }}
          >
            {client?.map(
              (option) =>
                option.id && (
                  <MenuItem key={option.id} dense divider value={option.id}>
                    {option.nombre}
                  </MenuItem>
                )
            )}
          </TextField>
        )}
      />
      <Button variant="outlined" type="submit">
        Filtrar
      </Button>
    </form>
  );
}
